import { Component } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Authority, Classifier } from '@amdb/drone/shared/models';
import { ToFlyAuthority } from '@amdb/drone/shared/models/to-fly-authority.model';
import { SysConfigService } from '@amdb/drone/@core/services/sys-config.service';
import { SysConfigToFlyAuthoritySection } from '@amdb/drone/shared/models/sys-config.model';

@Component({
    selector: 'app-to-fly-authority-modal',
    templateUrl: './to-fly-authority-modal.component.html',
    styleUrls: ['./to-fly-authority-modal.component.scss'],
})
export class ToFlyAuthorityModalComponent {
    authority: Authority;
    toFlyAuthority: ToFlyAuthority = {} as ToFlyAuthority;
    id: number;
    isEditMode: boolean;
    authorityDataGroups: Classifier[];

    toFlyAuthorityConfig: SysConfigToFlyAuthoritySection;

    constructor(protected ref: NbDialogRef<ToFlyAuthorityModalComponent>, private sysConfigService: SysConfigService, private toastrService: NbToastrService) {}

    async ngOnInit(): Promise<void> {
        try {
            this.toFlyAuthorityConfig = (await this.sysConfigService.getToFlyAuthoritySection()).data;
        } catch (ex) {
            console.error(ex);
            if (ex.error?.errors) {
                ex.error.errors.forEach(error => {
                    this.toastrService.danger(error, 'Kļūda');
                });
                return;
            }

            this.toastrService.danger('Kļūda atlasot kontaktinformāciju konfigurāciju', 'Kļūda');
            return;
        }

        if (!this.isEditMode) {
            this.toFlyAuthority.dataGroupId = this.authority.dataGroupAuthorities[0].dataGroupId;
        }
    }

    submit(): void {
        this.ref.close(this.toFlyAuthority);
    }

    dismiss() {
        this.ref.close();
    }
}
